import { eventHandler } from '@tracking/components/handlers/clickHover';
import { focusHandler } from '@tracking/components/handlers/focus';
import {
  setupIntersectionObserver,
  trackScrollHandler,
} from '@tracking/components/handlers/scroll';
import { mixPanelTracking } from
  '@tracking/components/handlers/mixPanelTracking';

export function setupEventListeners() {
  const observer = setupIntersectionObserver();
  const horizontalScrollHandlerFn = trackScrollHandler();
  const gtmElements = document.getElementsByClassName('gtm-track-element');
  for (let i = 0; i < gtmElements.length; i += 1) {
    const gtmEl = gtmElements[i];
    const allowedActions = gtmEl.getAttribute(
      'data-gtm-allowed-actions',
    ) || 'focus';
    if (allowedActions) {
      const allowedActionsArr = allowedActions.split(' ');
      if (allowedActionsArr.includes('click')) {
        gtmEl.addEventListener('click', eventHandler, true);
      }
      if (allowedActionsArr.includes('focus')) {
        gtmEl.addEventListener('focus', focusHandler, true);
      }
      if (allowedActionsArr.includes('hover')) {
        gtmEl.addEventListener('mouseover', eventHandler, true);
      }
      if (allowedActionsArr.includes('scroll') && observer) {
        observer.observe(gtmEl);
      }
      if (allowedActionsArr.includes('horizontal-scroll')) {
        gtmEl.addEventListener(
          'scroll', horizontalScrollHandlerFn, true,
        );
      }
    }
  }

  mixPanelTracking();
}
